import script from "./QHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./QHeader.vue?vue&type=script&lang=ts&setup=true"

import "./QHeader.vue?vue&type=style&index=0&id=08efc9c1&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08efc9c1"]])

export default __exports__